/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import Component from '@ember/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

export default class AssessmentEditDialog extends Component {
  @tracked
  assessmentDisplay;

  @action
  setAssessmentDisplay(value) {
    this.assessmentDisplay = value;
  }

  @tracked
  assessmentGradeSchedule;

  @action
  selectAssessmentGradeSchedule(schedule) {
    this.assessmentGradeSchedule = schedule;
  }

  @tracked
  canLearnersEdit;

  @action
  setCanLearnersEdit(value) {
    this.canLearnersEdit = value;
  }

  @tracked
  description;

  @action
  setDescription(value) {
    this.description = value;
  }

  @tracked
  isVisibleToLearners;

  @action
  toggleIsVisibleToLearners(isVisibleToLearners) {
    this.isVisibleToLearners = isVisibleToLearners;
    if (!isVisibleToLearners) {
      this.showHistoryToLearners = false;
      this.canLearnersEdit = false;
    }
  }

  @tracked
  label;

  @action
  setLabel(value) {
    this.label = value;
  }

  @tracked
  noGradesColumnsToShowCaregiversStudents;

  @action
  setNoGradesColumnsToShowCaregiversStudents(value) {
    this.noGradesColumnsToShowCaregiversStudents = value;
  }

  @tracked
  noGradesColumnsToShowStaff;

  @action
  setNoGradesColumnsToShowStaff(value) {
    this.noGradesColumnsToShowStaff = value;
  }

  @tracked
  showHistoryToLearners;

  @action
  setShowHistoryToLearners(value) {
    this.showHistoryToLearners = value;
  }

  @tracked
  showToCaregiversOnlyIfContent;

  @action
  setShowToCaregiversOnlyIfContent(value) {
    this.showToCaregiversOnlyIfContent = value;
  }

  @tracked
  type;

  @action
  setType(value) {
    this.type = value;
  }
}
